import { Component, Input, OnInit } from '@angular/core';
import { Breadcrumb } from 'src/app/models/breadcrumb';

@Component({
  selector: 'app-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.scss'],
})
export class BreadcrumbComponent implements OnInit {
  @Input() breadcrumb: Breadcrumb[];
  @Input() lightMode: boolean;

  constructor() {}

  ngOnInit(): void {}
}
